import {EMAIL_TEMPLATE_LOAD_SUCCESS, EMAIL_TEMPLATE_CREATE_SUCCESS, EMAIL_TEMPLATE_UPDATE_SUCCESS} from './emailTemplatesConstants';
import {emailTemplateService, mediaVersionService} from '_app/services';
import {addAlert} from '_app/shared/features/TransientNotifications/TransientNotificationsActions';

const loadEmailTemplateSuccess = emailTemplate => ({
	type: EMAIL_TEMPLATE_LOAD_SUCCESS,
	data: {
		emailTemplate
	}
});
const updateEmailTemplateSuccess = emailTemplate => ({
	type: EMAIL_TEMPLATE_UPDATE_SUCCESS,
	data: {
		emailTemplate
	}
});
const createEmailTemplateSuccess = emailTemplate => ({
	type: EMAIL_TEMPLATE_CREATE_SUCCESS,
	data: {
		emailTemplate
	}
});

export const loadEmailTemplate = (templateId, templateVersion) => dispatch => {
	return mediaVersionService
		.get(templateId, templateVersion)
		.done(data => {
			dispatch(loadEmailTemplateSuccess(data));
		})
		.fail((xhr, message) => {
			dispatch(addAlert(message));
		});
};

const updateEmailTemplate = emailTemplate => dispatch => {
	return mediaVersionService.update(emailTemplate)
		.then(function() {
			dispatch(updateEmailTemplateSuccess(emailTemplate));

			return emailTemplate;
		});
};

const createEmailTemplate = (mediaId, emailTemplate) => dispatch => {
	return emailTemplateService.create(mediaId, emailTemplate)
		.then(data => {
			dispatch(createEmailTemplateSuccess(data));

			return data;
		});
};

export const saveEmailTemplate = (mediaId, emailTemplate) => dispatch => {
	if (!emailTemplate.MediaID || !emailTemplate.Version) {
		return dispatch(createEmailTemplate(mediaId, emailTemplate));
	} else {
		return dispatch(updateEmailTemplate(emailTemplate));
	}
};